import React from "react";
import PageHeader from "../../components/PageHeader";
import AppUserViewComponent from "../../components/AppUsers/AppUserView";

class AppUserView extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="User Detail"
                            Breadcrumb={[
                                { name: "App Users", navigate: "/app-users" },
                                { name: "User Detail", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <AppUserViewComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AppUserView;
